<app-header-bar></app-header-bar>
<div class="container-fluid">
  <main role="main" class="pt-3 pb-5 px-4 page-content toggled">
    <app-side-bar></app-side-bar>
    <app-title-bar [component]="component"></app-title-bar>
    <app-spinner></app-spinner>
    <router-outlet (activate)="routerOutletActivated($event)"></router-outlet>
  </main>
</div>
